/**
 * How densely condition rows render.
 *
 * `compact` roughly halves a leaf condition's vertical footprint (128px -> 52px)
 * for surfaces that embed the builder in a dense list — LCM dynamic content
 * shows one builder per content variant, and at `default` the rows push the
 * variant assignment beside them off screen. It only ever applies to conditions
 * directly under the root group; see `isCompactCondition`.
 */
export type QueryBuilderVariant = "default" | "compact";

/**
 * Compact styling stops at the root group's direct children. Nested groups keep
 * the default chrome, which matters for more than looks: the only "Ungroup"
 * control lives in the AND/OR row that compact removes, so a nested group
 * rendered compactly could never be flattened. Compact surfaces can't create
 * nested groups (the actions menu they'd use is hidden), but an agent writing
 * the same condition through the API can, so this case is reachable.
 */
export const isCompactCondition = (
  variant: QueryBuilderVariant | undefined,
  level: number,
): boolean => variant === "compact" && level === 0;

/** Simple conditions without waterfalls render 66px high. Should update if condition styling changes */
export const defaultConditionHeight = 66;

export const waterfallHeight = 34;

export const dragPreviewId = "drag-preview";
